import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import Users from '../../users/Users';
import RatingEditModal from './ratingEditModal';

const ADMIN_LVL_MASTER = 0;				// same as Users.js
const ADMIN_LVL_ADMINLIMIT = 20;	// same as Users.js

class PlayerAdmin extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
 			auth: this.props.auth,
			globalAccessLevel: 99,
			isAdmin: false,
			isMasterAdmin: false,
			user: {
				_id: '0'
			},

			player: {
				_id: this.props.match.params.plid,
				firstname: '',
				lastname: '',
				special: '',
				email: '',
				address: '',
				city: '',
				tel1: '',
				tel2: '',
				sexe: '',
				inscriptionDate: '',
				lastRatings: [],
			},

			ratings: [],
			ratingTypes: [],
			modalRating: {
				_id: '0',
				userId: '0',
				ratingTypeId: '0'
			},
			showRatingEditModal: false,
			playerModified: false
		}

		this.loadPlayer = this.loadPlayer.bind(this);
		this.dispRatingsTable = this.dispRatingsTable.bind(this);
		this.createRatingRow = this.createRatingRow.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleReturnToList = this.handleReturnToList.bind(this);
		this.getAdminRightsInfo = this.getAdminRightsInfo.bind(this);
		this.handleModalCancel = this.handleModalCancel.bind(this);
	}

 	componentDidMount() {
		this.loadPlayer();
 	}
	
  loadPlayer() {
    var _this = this;
		var player = this.state.player;
		var playerId = this.state.player._id;

    // 0 means a new player to add, no info to retreive
		this.getAdminRightsInfo(function(user, globalAccessLevel) {

			var isAdmin = (globalAccessLevel <= ADMIN_LVL_ADMINLIMIT);
			var isMasterAdmin = (globalAccessLevel === ADMIN_LVL_MASTER);

			// reject access if not admin
			if (!isAdmin) {
				_this.props.history.push('/players/');
			}

			// get ratingTypes by organisations for this user
			Axios.get('/api/ratingTypes/byUserOrganisations/' + user._id).then(function(responseRatingTypes) {
			
				var ratingTypes = responseRatingTypes.data;
				player.inscriptionDate = moment(new Date()).utc().format("YYYY-MM-DD");

				_this.setState({
					globalAccessLevel: globalAccessLevel,
      		isAdmin: isAdmin,
      		isMasterAdmin: isMasterAdmin,
      		user: user,
      		ratingTypes: ratingTypes,
					player: player,
				});

				// new player or existing player ?
	      if (playerId !== '0') {

	      	// get existing player
	      	Axios.get('/api/players/playerid/' + playerId).then(function (responsePlayer) {

	      		// no result means _id was erroneous
	        	var player = responsePlayer.data;
			      if (player === '') {
			      	_this.props.history.push('/players/');		// exit to Players page if _id error
			      
			      } else {

					   	Axios.get('/api/ratings/byPlayerId/' + playerId).then(function (responseRatings) {

			      		var playerName = player.firstname + ' ' + player.lastname;
			      		if (player.special !== '') {
			      			playerName += ' (' + player.special + ')';
			      		}

			      		var inscrDate = player.inscriptionDate;
			      		if (inscrDate === null) {
				        	var todaysDate = new Date();
				        	inscrDate = todaysDate;
				        }
			        	inscrDate = moment(inscrDate).utc().format("YYYY-MM-DD");

			        	player.inscriptionDate = inscrDate;

			        	_this.setState({
									player: player,
			        		ratings: responseRatings.data,
			        		playerName: playerName,
									showPlayerEditModal: false,
			        	});
				    	});
					  }
					});
		    }
			});
		});
	}

	render() {
    // console.log('PlayerAdmin: render');
    // console.log(this.props);
    // console.log(this.state.user);

    var defaultDate = new Date();
    defaultDate = moment(defaultDate.toISOString()).utc().format("YYYY-MM-DD");

		return (
			<div className="animated fadeIn">

        <div className="row">
        <div className="col-md-12 col-xs-12">
          <h4>LA PUISSANCE DES STATS</h4>
        </div>
        </div>
        <hr/>

        <div className="row">
        <div className="col-md-10">
          <h5>
          	Fiche de joueur
	         	{(this.state.player._id === '0') ?
  	        	<span> - nouveau joueur </span>
  	        	: null}
          </h5>
					
          <p> Entrer les informations du joueur. </p>
          <ul className="ul-left-aligned">
	          <li>
	          Champ "Précision spéciale": courte note permettant de faire la distinction entre deux joueurs 
	          de même Prénom et Nom, affichée entre parenthèses dans les classements et à différents autres endroits. </li>
	          <li>
	          Cotation: ne pas oublier d'inscrire une première cotation pour le joueur si vous avez un système de 
	          cotation pour votre organisation.
	          </li>
	          <li>
	          Il est possible de créer, modifier ou supprimer une information de cotation seulement si vous
						êtes administrateur de l'organisation qui gère ce système de cotation.  Dans le cas particulier où vous
						auriez besoin de surpasser cette règle, contactez Statelo.
	          </li>
	          <li>
	          Dans un rare cas où vous devriez supprimer définitivement un joueur, contactez Statelo.
	          </li>
          </ul>

	        {(this.state.isMasterAdmin) ?
		        <div className="row row-margin-bottom-10">
		        <div className="col-md-12">
							<i> [Master Admin Only:  id = {this.state.player._id}] </i> <br/>
							<i> [User: {this.state.user.name} [{this.state.user._id}] </i>
						</div>
						</div>
					: null}

				</div>
				</div>
				<hr/>

        <div className="row row-margin-bottom-10">
        <div className="col-md-6">
	        <strong> Informations générales </strong>
				</div>
				</div>

				{/* ----- FORM ----- */}
        <form className="form-horizontal" id='playerForm' onSubmit={this.handleSubmit}>
        <div className="row">
        <div className="col-md-4">

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Prénom </span> <br/>
					<input type="text" className="form-control form-control-sm" id="firstname" placeholder="Prénom" 
						value={this.state.player.firstname || ''} onChange={this.handleChange} required/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Nom </span> <br/>
					<input type="text" className="form-control form-control-sm" id="lastname" placeholder="Nom de famille"
						value={this.state.player.lastname || ''} onChange={this.handleChange} required/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Précision spéciale </span> <br/>
					<input type="text" className="form-control form-control-sm" id="special" placeholder="Précision spéciale"
						value={this.state.player.special || ''} onChange={this.handleChange}/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Adresse </span> <br/>
					<input type="text" className="form-control form-control-sm" id="address" placeholder="numéro, rue, ville, CP"
						value={this.state.player.address || ''} onChange={this.handleChange}/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Ville </span> <br/>
					<input type="text" className="form-control form-control-sm" id="city" placeholder="ville"
						value={this.state.player.city || ''} onChange={this.handleChange}/>
				</div>
				</div>
				</div>

        <div className="col-md-4">

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Téléphone 1 </span> <br/>
					<input type="tel" className="form-control form-control-sm" id="tel1" placeholder="000-000-0000"
						value={this.state.player.tel1 || ''} onChange={this.handleChange}/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Téléphone 2 </span> <br/>
					<input type="tel" className="form-control form-control-sm" id="tel2" placeholder="000-000-0000"
						value={this.state.player.tel2 || ''} onChange={this.handleChange}/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Courriel </span> <br/>
					<input type="email" className="form-control form-control-sm" id="email" placeholder="Courriel"
						value={this.state.player.email || ''} onChange={this.handleChange}/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Date d'inscription </span> <br/>
          <input className="form-control form-control-sm" type="date" id="inscriptionDate" 
          	value={this.state.player.inscriptionDate || defaultDate} 
            onChange={this.handleChange}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<span className="small"> Sexe </span> <br/>
 		  		<select className="form-control form-control-sm input-sm" type="text" id="sexe" 
		  			value={this.state.player.sexe} onChange={this.handleChange}>
						<option value='' key='optsexe.0'> - </option>
						<option value='M' key='optsexe.1'> Masculin </option>
						<option value='F' key='optsexe.2'> Féminin </option>
					</select>
				</div>
				</div>


				</div>
				</div>
				<br/>

				{/* Buttons */}
        <div className="row row-margin-bottom-10">
        <div className="col-md-12">
					<button type="button" className="btn btn-primary btn-sm btn-margin-right-20 btn-extra-padding" onClick={this.handleReturnToList}>
						Retour à la liste
					</button>
					<button type="submit" className="btn btn-primary btn-sm btn-margin-right-20 btn-extra-padding">
						Sauvegarder
					</button>
        	{(this.state.playerModified) ? <p className="unsavedMessage"> * modifications non-sauvegardées * </p> : null}
				</div>
				</div>
				<hr/>
				</form>
				{/* End of form */}

				{/* Ratings table */}
        <div className="row row-margin-bottom-10">
        <div className="col-md-10">
	        {this.dispRatingsTable()}
				</div>
				</div>
				<hr/>

				<br/><br/>

				{/* Modal */}
				<RatingEditModal 
					className = {this.props.className}
					showModal = {this.state.showRatingEditModal}
					handleModalCancel = {this.handleModalCancel}
					modalRating = {this.state.modalRating}
					userId = {this.state.user._id}
					playerId = {this.state.player._id}
					playerName = {this.state.playerName}
					ratingTypes = {this.state.ratingTypes}
					loadPlayer = {this.loadPlayer}
				/>

			</div>
		);
	}

	dispRatingsTable() {

		var addRatingButtonDisabled = (this.state.ratingTypes.length === 0);

		var playerId = this.state.player._id;
		if (playerId === '0') {
			return (
	      <div className="row">
	      <div className="col-md-12">
	        <strong> Informations de cotation </strong>
		      <p> Sauvegarder les informations du joueur afin d'accéder à la section sur la cotation </p>
				</div>
				</div>
			)
		} else {

			return (
	      <div className="row">
	      <div className="col-md-12">
	        <div className="row row-margin-bottom-10">
	        <div className="col-md-6">
		        <strong> Informations de cotation </strong>
					</div>
					</div>
		       		
		   		<div className="table-responsive">
			  	<table className="table table-sm table-striped table-hover">
						<thead>
						<tr>
	      			<th> Date </th>
	      			<th> Type </th>
	      			<th> Cote </th>
	      			<th> Temporaire </th>
	      			<th> Administrateur </th>
	      			<th> Notes / Commentaires </th>
	      			<th colSpan="2"> Modifications </th>
						</tr>
						</thead>

			  		<tbody>
							{this.state.ratings.length !== 0 ? 
			  				this.state.ratings.map(this.createRatingRow) :
		      			<tr><td colSpan="99"> Aucune cotation </td></tr>
							}
		  			</tbody>
		  		</table>
					</div>

	        <div className="row row-margin-bottom-10">
	        <div className="col-md-12">
						<button type="button" className="btn btn-primary btn-sm btn-margin-right-20 btn-player-width" 
							onClick={this.handleAddEditRating.bind(this, {_id: '0'})} disabled={addRatingButtonDisabled}> 
							Ajouter une cotation
						</button>
						{addRatingButtonDisabled ? 
							<p><i> Pour ajouter une cotation, vous devez avoir des droits sur les cotations.<br/>Contactez Statelo. </i></p>
							: null}
						<p> Les informations de cotations sont sauvegardées automatiquement </p>
					</div>
					</div>

				</div>
				</div>
			)
		}
	}

	createRatingRow(ratingRow, ratingRowIdx) {

		var tempTxt = '---';
		if (ratingRow.ratingTemp) {
			tempTxt = 'TEMP';
		}

		var ratingEditAllowed = false;
		var userOrganisations = this.state.user.organisationsId;
		var ratingTypeOrg = ratingRow.ratingOrganisationId;

		userOrganisations.forEach(function(org) {
			if (org.toString() === ratingTypeOrg.toString()) {
				ratingEditAllowed = true;
			}
		});

		return (
			<tr key={'te.' + ratingRowIdx}>
				<td> {moment(ratingRow.date).utc().format('YYYY-MM-DD')} </td>
				<td> {ratingRow.ratingTypeName} </td>
				<td> {ratingRow.ratingValue} </td>
				<td> {(ratingRow.ratingTemp) ? <span> TEMP </span> : null}	</td>
				<td> {ratingRow.userName} </td>
				<td> {ratingRow.comment} </td>

				{(ratingEditAllowed) ?
					<td> <input name={'edit.' + ratingRow} type="button" onClick={this.handleAddEditRating.bind(this, ratingRow)} value="Éditer"/>	</td>
				: <td colSpan='2'> (non permises) </td> }

				{(ratingEditAllowed) ?
					<td> <input name={'delete.' + ratingRow} type="button" onClick={this.handleDeleteRating.bind(this, ratingRow)} value="Supprimer"/> </td>
				: null}

      </tr>
		)
	}

	handleAddEditRating(ratingItem) {
		 console.log('handleAddEditRating');
		 console.log(this.state.ratingTypes);

		var modalRating = {};
		var ratingTypes = this.state.ratingTypes;

		// new rating ?
		if (ratingItem._id === '0') {

			// ratingTypes existing for this user?
			if (ratingTypes.length > 0) {
				modalRating = {
					playerId: this.state.player._id,
					date: moment(new Date()).format("YYYY-MM-DD"),
					ratingTypeId: ratingTypes[0]._id,
					ratingValue: ratingTypes[0].values[0],
					ratingTemp: false,
					userId: this.state.user._id,
					comment: ''
				};
				this.setState({
					modalRating: modalRating,
					showRatingEditModal: true
				});
			} else {
				// This should never happen, since the edit rating button should not be visible if user has no rights on ratings
				alert('Erreur: vous devez avoir des droits sur les cotations.')
			}

		} else {
			modalRating = JSON.parse(JSON.stringify(ratingItem));
			this.setState({
				modalRating: modalRating,
				showRatingEditModal: true
			});
		}
	}

	handleDeleteRating(ratingItem) {

		// console.log(ratingItem);

		var _this = this;
		var confirmAns = window.confirm('Voulez-vous vraiment supprimer la cotation suivant: \n' + 
			moment(ratingItem.date).utc().format('YYYY-MM-DD') + ' - ' + ratingItem.ratingTypeName + ' - ' + ratingItem.ratingValue);
	
		if (confirmAns) {
			// Save to DB
			Axios.delete('/api/ratings/' + ratingItem._id)
			.then(function(response) {
				_this.loadPlayer();
			})
			.catch(function(error) {
				console.log(error);
			});     
		}
	}

	handleModalCancel() {
		this.setState({ 
			showRatingEditModal: false
		});
	}

	handleSubmit(e) {
		e.preventDefault();     // do nothing on submit
		var _this = this;
		var playerData = this.state.player;
		if (playerData.sexe === "") {
			alert("Le sexe n'a pas été spécifié, n'oubliez pas de le faire (s'il-y-a lieu) !");
		}

		Axios.post('/api/players/createModify', {
			playerId: playerData._id,		//playerId,
			playerData: playerData
		})
		.then(function(response) {

			// console.log(response.data);
			// Check if player has been upserted
			if (response.data.upserted) {
				playerData._id = response.data.upserted[0]._id;
			}

			_this.setState({
				player: playerData,
				playerModified: false
			});
		})
		.catch(function(error) {
			console.log(error);
		});
	}

	handleChange(e) {
		var player = this.state.player;
		player[e.target.id] = e.target.value;

    this.setState({
    	player: player,
    	playerModified: true
    });
	}

	handleReturnToList() {
		// return to players list only if not modified or if user confirms losing modifications
		const path = '/players';
		if (this.state.playerModified) {
			var ans = window.confirm('La fiche du joueur a été modifiée, êtes-vous certain de vouloir retourner' + 
				' à la liste de joueurs et perdre les modifications apportées ?\n\n' + 
				'Choisir \'Annuler\' et cliquer sur \'Sauvegarder\' pour enregistrer vos modifications.');
			if (ans === true) {
				this.props.history.push(path);
			}
		} else {
			this.props.history.push(path);
		}
	}

	getAdminRightsInfo(callback) {
		var _this = this;
		if (_this.state.auth.isAuthenticated()) {
			var profile = _this.props.auth.getProfile();
			var authUserId = profile.user_id;
			Users.getUserInfo(authUserId, function(user) {
				Users.getAccessLevel(profile, function(globalAccessLevel) {
					callback(user, globalAccessLevel);
				});
			});
		} else {
			callback({_id: '0'}, 99);
		}
	}

}

export default PlayerAdmin;